import axios from "axios";
import { useEffect, useState } from "react";
const CaseStudy = () => {
  const [caseData, setCaseData] = useState([]);
  const fetchcaseDetails = async () => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/case`
    );
    console.log(data);
    setCaseData(data);
  };
  useEffect(() => {
    fetchcaseDetails();
  }, []);

  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 mt-24 md:px-12 px-4">
      {caseData.map((caseData) => {
        return (
          <div className="border border-slate-300 m-4 flex md:flex-row flex-col py-2 px-4 rounded-lg">
            <img
              className="w-[250px] h-[200px] object-cover rounded-xl"
              src={caseData.image}
              alt=""
            />
            <div className="ml-4 md:mt-0 mt-2">
              {caseData.process && (
                <div>
                  <h1 className="font-bold text-xl">{caseData.role}</h1>
                  <p className="my-2">{caseData.process}</p>
                </div>
              )}
              {caseData.goal && (
                <div className="flex items-center">
                  <span className="font-semibold">Goal : </span>
                  <p className=""> {caseData.goal}</p>
                </div>
              )}
              {caseData.like && (
                <div className="flex items-center my-2">
                  <span className="font-semibold">Like : </span>
                  <p className=""> {caseData.like}</p>
                </div>
              )}
              {caseData.research && (
                <div className="flex items-center my-2">
                  <span className="font-semibold">Research : </span>
                  <p className=""> {caseData.research}</p>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default CaseStudy;
